// extracted by css-extract-rspack-plugin
export default {"boxWrap":"boxWrap-YXD68P","checkboxItem":"checkboxItem-qPkbFW"};